export default {
  // 本机测试
  // 'ROOT_API_URL': 'http://127.0.0.1:8000',
  // 线上测试
  // 'ROOT_API_URL': '',
  // 线上开发
  'ROOT_API_URL': 'http://simulate-api.51easymaster.com',
  'DEBUG': true
}



// WEBPACK FOOTER //
// ./src/config/config.js